// Lightweight event tracking. Uses PostHog (already initialized in index.html) when
// available, and also pushes to window.dataLayer so a future GTM/GA4 tag can consume
// the same events. Campaign attribution (UTMs) is preserved by PostHog automatically.
export function trackEvent(name, params = {}) {
  try {
    const payload = { ...params };
    if (typeof window !== 'undefined') {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(name, payload);
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...payload });
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    }
  } catch (e) {
    /* analytics must never break the UI */
  }
}
